import { render, staticRenderFns } from "./LeaveDaysManager.vue?vue&type=template&id=15a58880"
import script from "./LeaveDaysManager.vue?vue&type=script&lang=js"
export * from "./LeaveDaysManager.vue?vue&type=script&lang=js"
import style0 from "./LeaveDaysManager.vue?vue&type=style&index=0&id=15a58880&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports